import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { dollars, formatCurrency } from "@/domains/library/format"
import { TokenIcon } from "@/domains/tokens/components/token-icon"

interface ZapExecutingProps {
  store: ZapStore
}

export const ZapExecuting = observer(({ store }: ZapExecutingProps) => {
  if (!store.estimate) return null
  if (!store.pool) return null
  if (!store.zapToken) return null

  return (
    <div className="text-t100 border-p400-light bg-p400 flex h-40 items-center justify-center rounded-lg border px-4 py-3 text-center">
      <div>
        <p className="text-t200 mb-1">Executing Zap</p>
        <div className="mb-2 flex items-center justify-center gap-2 text-lg md:text-4xl">
          {formatCurrency(store.displayInputAmount)}
          <TokenIcon token={store.zapToken} size={32} />
          {store.zapToken?.symbol}
        </div>

        <div className="text-t200 text-sm">
          <p>
            To receive {dollars(store.estimate.context.outputAmountUsd)} {store.pool?.displayName}
          </p>
          <p className="text-t200 text-sm">
            @ {store.estimate.context.slippageTolerancePercentage.toFixed(2)}% slippage
          </p>
        </div>
      </div>
    </div>
  )
  // return (
  //   <div className="space-y-4">
  //     {/* Execution Status */}
  //     <div className="rounded bg-green-50 p-6 text-center">
  //       <div className="flex flex-col items-center space-y-3">
  //         <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-green-600"></div>
  //         <div className="font-medium text-green-600">Executing Zap</div>
  //         <div className="text-sm text-green-500">Processing your zap transaction...</div>
  //       </div>
  //     </div>

  //     {/* Execution Details */}
  //     {store.executionResponse && (
  //       <div className="rounded bg-gray-100 p-4">
  //         <h3 className="mb-2 font-semibold">Execution Details:</h3>
  //         <div className="space-y-2 text-sm">
  //           <div>Order ID: {store.executionResponse.context.orderId}</div>
  //           <div>Input Amount: {store.executionResponse.context.inputAmount}</div>
  //           <div>Output Amount: {store.executionResponse.context.outputAmount}</div>
  //           <div>Min Output: {store.executionResponse.context.minOutputAmount}</div>
  //           <div>Slippage: {store.executionResponse.context.slippageTolerancePercentage.toFixed(2)}%</div>
  //           {/* <div>Gas Limit: {store.executionResponse.context.gasLimit}</div> */}
  //           {store.executionResponse.context.route && (
  //             <div>Route: {store.executionResponse.context.route.join(" → ")}</div>
  //           )}
  //         </div>
  //       </div>
  //     )}

  //     {/* Transaction Hash */}
  //     {store.executionTxHash && (
  //       <div className="rounded bg-green-50 p-3">
  //         <div className="text-sm text-green-600">
  //           <div className="font-medium">Transaction Submitted:</div>
  //           <div className="break-all font-mono text-xs">{store.executionTxHash}</div>
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // )
})
